import { AppState } from "@shared/interfaces";
import { createSelector } from "reselect";

const selectSensor = (state: AppState) => state.sensor;

export const getSensors = () => createSelector(selectSensor, (state) => state.sensors);
export const getSensorsTotal = () => createSelector(selectSensor, (state) => state.sensorsTotal);
export const getFilter = () => createSelector(selectSensor, (state) => state.filter);
